import { useQuery } from "@tanstack/react-query";
import { useRuntime } from "../runtime/RuntimeContext";

// res.language master rows (active only). Used read-only to resolve the user's
// saved language_id → code + direction so the layout can switch (LTR/RTL).
// Gated by `enabled` so users without a language preference never fetch it.
export function useLanguages(enabled = true) {
    const runtime = useRuntime();
    return useQuery({
        queryKey: ["languages"],
        queryFn: () => runtime.services.locale.listLanguages(),
        staleTime: Infinity,
        enabled,
    });
}
